import React, { Component } from 'react';
import SDIConstants from '../SDIConstants';
import * as $ from "jquery";
import * as CookieService from '../CookieService';
import ImportScript from './import-script';
import * as MenuAction from '../actions/MenuAction'; //WW-920_API_PC_27
import * as InteractiveDiagramAction from '../actions/InteractiveDiagramAction';
import InteractiveDiagramStore from '../stores/InteractiveDiagramStore';

//WW-1163 global variable declaration -Vishwa S
let Url = "";
let ApiKey = "";
let AccountCode = "";
let PublicKey = "";
let UserName = "";
let Password = "";
let BaseUrl = "";
//const handleThirdPartyButtonClick=()=>{
//    console.error("clicked")
//}
export default class InteractiveDiagramComponent extends Component {
    componentDidMount() {
        
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //ImportScript("https://walmart.sdi.com/Walmart-API/Pikclix/pikclix.min.js?v=2.1.1.4")
        //WW-1163 fetch dynamic values for customdata formation
        let pageloadBO = {
            source: "WEB"
        }
        InteractiveDiagramAction.pageLoad(pageloadBO);

        InteractiveDiagramStore.on('pageLoad', this.pageLoadResponse);
        //this.poll();

        //const thirdPartyButton = document.getElementsByClassName('impx_btn');

        //if (thirdPartyButton != null && thirdPartyButton != undefined) {
        //    thirdPartyButton.addEventListener('click', this.handleThirdPartyButtonClick);
        //}
    }

    componentWillUnmount() {
        var tags = document.getElementsByTagName('script');
        for (var i = tags.length; i >= 0; i--) {
            if (tags[i] && tags[i].getAttribute('src') != null && (tags[i].getAttribute('src').indexOf("8180") != -1 || tags[i].getAttribute('src').indexOf("loki") != -1)) {
                tags[i].parentNode.removeChild(tags[i]); //remove element by calling parentNode.removeChild()
            }
        }
        InteractiveDiagramStore.removeListener('pageLoad', this.pageLoadResponse);

    }

    //WW-1163 pageload response method
    pageLoadResponse = () => {
        let PageLoadResponse = JSON.parse(InteractiveDiagramStore.pageLoadResponse);
        if (PageLoadResponse != undefined && PageLoadResponse != null && PageLoadResponse.length > 0) {
            Url = PageLoadResponse[0].URL;
            ApiKey = PageLoadResponse[0].APIKEY;
            AccountCode = PageLoadResponse[0].ACOUNTCODE;
            PublicKey = PageLoadResponse[0].PUBLICKEY;
            UserName = PageLoadResponse[0].USERNAME;
            Password = PageLoadResponse[0].PASSWORD;
            BaseUrl = PageLoadResponse[0].BASEURL;
            ImportScript(PageLoadResponse[0].HOSTURL)
            this.poll();
        }
    }

    poll = () => {
        //WW-1163 Check for thirdparty and #WO type
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
        // Filter the cart items to check if there are any equipment items
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
        let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
        let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";
        if (window.idw) {
            if (window.initializeData === undefined) {
                window.idw.init({
                    selector: '#impaqx-interactive-diagram-app-block', // Html element you would like to load the interactive diagram widget into
                    url: Url, // This is the url to your interactive diagram system
                    apiKey: ApiKey, // Your extremeb2b account interactive diagram api key goes here
                    accountCode: AccountCode,// Your extremeb2b account id goes here
                    btn_color: 'orange', // Color of the action button to add to cart/search the item on the diagram
                    btn_text_color: 'black', // Button text color of the action button to add to cart/search the item on the diagram
                    non_stock_btn_color: '#3e79f7', // Color of the non stock item action button to add to cart/search the item on the diagram
                    non_stock_btn_text_color: 'white', // Button text color of the non stock item action button to add to cart/search the item on the diagram
                    highlighter_border_color: 'ff0000', // This is the color code for the border of each part marked on the diagram
                    highlighter_color: 'ffff4d',
                    type: 'group',// Your extremeb2b account id goes here

                    addToCart_CallBack: this.handleAddToCart_CallBack,
                    customData: {

                        "state": CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                        "shiptTo": CookieService.getLocalStorageValues("HOME_STORE"),
                        "UserID": CookieService.getLocalStorageValues("Session_UserID"),
                        "BusUnit": CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        "PublicKey": PublicKey,
                        "UserName": UserName,
                        "Password": Password,
                        "Base_URL": BaseUrl,
                        "Make": CookieService.getLocalStorageValues("WO_Make") == null || CookieService.getLocalStorageValues("WO_Make") == undefined ? "" : CookieService.getLocalStorageValues("WO_Make").replace('"', ""),
                        "Model": CookieService.getLocalStorageValues("WO_Model") == null || CookieService.getLocalStorageValues("WO_Model") == undefined ? "" : CookieService.getLocalStorageValues("WO_Model").replace('"', ""),
                        "Asset": localStorage.getItem("WOAssetTag") == null || localStorage.getItem("WOAssetTag") == undefined ? "" : localStorage.getItem("WOAssetTag"),
                        "isExistingUserCart": WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false ? true : false,
                        "ItemType": hasEquipmentItem.length > 0 ? 'Equipment' : hasQuoteItem.length > 0 ? 'Quote' : '',

                    },


                });
                //handleThirdPartyButtonClick: function () {

                //}
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            } else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                window.initializeData()
            }

        } else {
            setTimeout(this.poll, 500);
        }

    }
    //WW-920_API_PC_28
    handleAddToCart_CallBack = () => {
        MenuAction.refreshCartCount();
    }
    render() {
        return (
            <div>
                <div className="container-fluid content-section content-margin custom-mb" style={{ "marginTop": "135px" }}>
                    <div className="row">
                        <div className="container-fluid mobile-header-label content-margin" style={{ "paddingRight": "5px", "paddingLeft": "5px" }}>
                            <div id="impaqx-interactive-diagram-app-block">
                                <div id="load">
                                    <div>G</div>
                                    <div>N</div>
                                    <div>I</div>
                                    <div>D</div>
                                    <div>A</div>
                                    <div>O</div>
                                    <div>L</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}